import Swiper from "@modules/swiper";
import { Navigation, A11y, Keyboard, Pagination, EffectFade } from "@modules/swiper/modules";

/*import '@modules/swiper/css';*/
import "@modules/swiper/modules/a11y";
import "@modules/swiper/modules/keyboard";
import "@modules/swiper/modules/navigation";
import "@modules/swiper/modules/pagination";
import $ from "@modules/jquery";
var language = document.getElementsByTagName("html")[0].getAttribute("lang");
var SlideMessagePrev = language === "it" ? "Mostra immagine precedente" : "Vorheriges Bild anzeigen";
var SlideMessageNext = language === "it" ? "Mostra immagine successiva" : "Nächstes Bild anzeigen";
export default () => {

    const sliderSlideImageTitleText  = document.querySelector(".sliderSlideImageTitleText .swiper");

    if (sliderSlideImageTitleText ) {

        const swiperInstance = new Swiper(sliderSlideImageTitleText , {
            modules: [Navigation, Pagination, A11y, Keyboard, EffectFade],
            a11y: {
                prevSlideMessage: SlideMessagePrev,
                nextSlideMessage: SlideMessageNext,
            },
            loop: true,
            slidesPerView: 1,
            effect: "fade",
            fadeEffect: {
            crossFade: true,
            },
            effect: "fade",
            keyboard: {
                enabled: true,
                onlyInViewport: true,
                pageUpDown: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-sliderSlideImageTitleText',
                prevEl: '.swiper-button-prev-sliderSlideImageTitleText',
            },
            breakpoints: {
                // When window width is >= 768px
                768: {
                    // slidesPerView: 1.25
                    slidesPerView: 1
                }
            }

        });
        swiperInstance.on('slideChange', function () {
            $('.pagination-sliderSlideImageTitleText span').text(this.realIndex + 1);
        }); 
    }

}